export const TRANSITIONS = {
    assign: { from: ['OPEN'], to: 'ASSIGNED', cap: 'jobs.assign', needsMechanic: true, label: 'Assign' },
    reassign: {
        from: ['ASSIGNED', 'IN_PROGRESS'],
        to: 'ASSIGNED',
        cap: 'jobs.assign',
        needsMechanic: true,
        needsReason: true,
        label: 'Reassign',
    },
    hold: { from: ['IN_PROGRESS'], to: 'ON_HOLD', cap: 'jobs.hold', needsHoldReason: true, label: 'Put On Hold' },
    resume: { from: ['ON_HOLD'], to: 'IN_PROGRESS', cap: 'jobs.hold', label: 'Resume' },
    ready: { from: ['IN_PROGRESS'], to: 'READY_FOR_REVIEW', cap: 'jobs.ready', label: 'Ready for Review' },
    sendBack: { from: ['READY_FOR_REVIEW'], to: 'IN_PROGRESS', cap: 'jobs.sendBack', needsReason: true, label: 'Send Back' },
    close: { from: ['READY_FOR_REVIEW'], to: 'CLOSED', cap: 'jobs.close', label: 'Close' },
    reopen: { from: ['CLOSED'], to: 'IN_PROGRESS', cap: 'jobs.reopen', needsReason: true, label: 'Reopen' },
};
export function checkTransition(action, actor, status) {
    const rule = TRANSITIONS[action];
    if (!actor.caps.includes(rule.cap) || (actor.base === 'MECHANIC' && !actor.isAssignee)) {
        return { ok: false, code: 'FORBIDDEN', message: `You may not ${rule.label}` };
    }
    if (!rule.from.includes(status)) {
        return { ok: false, code: 'BAD_STATUS', message: `Can't ${rule.label} a job that is ${status}` };
    }
    return { ok: true };
}
export function allowedActions(actor, status) {
    return Object.keys(TRANSITIONS).filter((a) => checkTransition(a, actor, status).ok);
}
// ---- voids: a second person always approves (docs/01; OPEN_QUESTIONS D9) ----
export function canRequestVoid(caps, status) {
    if (!caps.includes('void.request'))
        return { ok: false, code: 'FORBIDDEN', message: 'You may not request a void' };
    if (status === 'CLOSED' || status === 'VOIDED') {
        return { ok: false, code: 'BAD_STATUS', message: `Can't void a job that is ${status}` };
    }
    return { ok: true };
}
/** Invariant: no capability or setting lets anyone approve their own void request. */
export function canDecideVoid(caps, userId, requestedBy) {
    if (!caps.includes('void.approve'))
        return { ok: false, code: 'FORBIDDEN', message: 'You may not decide a void' };
    if (userId === requestedBy)
        return { ok: false, code: 'FORBIDDEN', message: 'Nobody approves their own void request' };
    return { ok: true };
}
//# sourceMappingURL=workflow.js.map